"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadScript = void 0;
/**
 * Load script on src and run function on script load
 */
function loadScript(src, onload = null, onerror = null, immediate = true) {
    const script = document.createElement('script');
    script.src = src;
    script.onload = onload;
    script.onerror = onerror;
    script.type = 'text/javascript';
    const addScript = () => document.body.appendChild(script);
    if (immediate) {
        addScript();
    }
    else {
        window.addEventListener('load', addScript);
    }
}
exports.loadScript = loadScript;
